import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Main } from "@/app/layout/Main";
import { useCreateStudentGroup } from "../api/queries";
import { StudentGroupForm } from "../ui/student-groups/StudentGroupForm";

export function StudentGroupCreatePage() {
  const nav = useNavigate({ from: "/app/master/student-groups/create" });
  const createStudentGroup = useCreateStudentGroup();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ກຸ່ມນັກຮຽນ", to: "/app/master/student-groups" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງກຸ່ມນັກຮຽນ
            </h2>
            <p className="text-muted-foreground">ສ້າງກຸ່ມນັກຮຽນໃໝ່ໃນລະບົບ.</p>
          </div>

          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/master/student-groups" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <StudentGroupForm
            onSubmit={async (vals) => {
              try {
                await createStudentGroup.mutateAsync(vals);

                nav({ to: "/app/master/student-groups" });
              } catch (error) {
                // Error handling is done by the mutation
              }
            }}
            submitting={createStudentGroup.isPending}
          />
        </div>
      </Main>
    </>
  );
}
